import { MapLayer, withLeaflet } from "react-leaflet";

import L from "leaflet";
import LeafletOverPassLayer from "leaflet-overpass-layer";
import type { MapLayerProps } from "react-leaflet";

type LeafletElement = LeafletOverPassLayer;
type Props = MapLayerProps;

class OverPassLayer extends MapLayer<LeafletElement, Props> {
    createLeafletElement(props: Props): LeafletElement {
        try {
            const self = this;
            const el = new LeafletOverPassLayer({
                query: `
                node
                [amenity=${props.amenity}]
                ({{bbox}});
                out;`,
                endpoint: "https://overpass-api.de/api/",
                minZoomIndicatorEnabled: false,
                markerIcon: props.marker,
                onSuccess(data) {
                    for (let i = 0; i < data.elements.length; i++) {
                        let pos;
                        let marker;
                        const e = data.elements[i];

                        if (e.id in this._ids) {
                            continue;
                        }

                        this._ids[e.id] = true;

                        if (e.type === 'node') {
                            pos = L.latLng(e.lat, e.lon);
                        } else {
                            pos = L.latLng(e.center.lat, e.center.lon);
                        }

                        if (this.options.markerIcon) {
                            marker = L.marker(pos, { icon: this.options.markerIcon(e.tags.name) });
                        } else {
                            marker = L.circle(pos, 20, {
                                stroke: false,
                                fillColor: '#E54041',
                                fillOpacity: 0.9
                            });
                        }

                        if ('name' in e.tags) {
                            const popupContent = self.getPopupHTML(e.tags);
                            const popup = L.popup().setContent(popupContent);
                            marker.bindPopup(popup);
                            marker.on('mouseover', function (e) {
                                this.openPopup();
                            });
                            marker.on('mouseout', function (e) {
                                this.closePopup();
                            });
                        }

                        this._markers.addLayer(marker);
                    }
                },
                onError: function (xhr) { return false },
                onTimeout: function (xhr) { return false },
            });
            return el;
        } catch (error) {
            return <></>
        }
    }

    getPopupHTML(tags) {
        const div = `
            <div class="ant-popover-inner" role="tooltip" >
                <div class="ant-popover-title">
                    <span>${tags.amenity === "school" ? "Escuela" : "Hospital"}</span>
                </div>
                <div class="ant-popover-inner-content">
                    <div>
                        ${typeof tags.name != "undefined" ? `<p><strong>Nombre:</strong> ${tags.name}</p>` : ""}
                        ${typeof tags["addr:city"] != "undefined" ? `<p><strong>Ciudad:</strong> ${tags["addr:city"]}</p>` : ""}
                        ${typeof tags["addr:street"] != "undefined" ? `<p><strong>Calle:</strong> ${tags["addr:street"]}</p>` : ""}
                        ${typeof tags.phone != "undefined" ? `<p><strong>Telefono:</strong> ${tags.phone}</p>` : ""}
                    </div>
                </div>
            </div>
        `

        return div;
    }
}

export default withLeaflet<Props, OverPassLayer>(OverPassLayer);

